import { getFromLocalStorage, setToLocalStorage, api } from '@/shared'
import { userActions } from '@/entity/user'
import { actions } from './actions'
import { companyActions } from '@/entity/company'
import { employerProfileThunks } from '@features/employerProfile/model'

export const getCurrentUser = (payload, params = {}, onSuccess = () => {}, onError = () => {}) => {
	//TODO ID и CODE по умолчанию, используется в случае если company.id равен null для ФЛ
	const DEFAULT_ID = 123456789

	return async (dispatch) => {
		try {
			dispatch(actions.toggleLoading(true))
			const { data: sendData } = payload
			const user = await api.auth.getCurrentUser(sendData, params)
			const { currentBin, companies, currentFlEmployer } = user || {}
			const activeRoleFroLS = getFromLocalStorage('activeRole')
			const activeCompany = getFromLocalStorage('activeCompany')
			const initialCompany =
				activeCompany ||
				(currentBin &&
					companies.find(({ bin, flEmployer }) => bin === currentBin && flEmployer === currentFlEmployer)) ||
				companies[0]
			const parsedCompanies = companies.map((company) => ({
				id: company.id !== null ? company.id : DEFAULT_ID,
				rus: company.companyName,
				kz: company.companyName,
				code: String(company.id !== null ? company.id : DEFAULT_ID),
			}))

			setToLocalStorage('roles', user?.roles || [])
			setToLocalStorage('isLogged', true)
			setToLocalStorage('activeStaffBranch', user.currentStaffBranch)

			dispatch(
				userActions.setUser({
					roles: user?.roles || [],
					currentFlEmployer: user?.currentFlEmployer,
					...user?.personDetails,
					personDetailsId: user?.personDetails?.id,
					email: user?.email,
					id: user?.id,
					manager: user?.manager,
					errorCompanies: user?.errorCompanies,
				})
			)
			dispatch(userActions.setActiveRole(activeRoleFroLS))
			dispatch(userActions.setEmployerCompanies(parsedCompanies))
			dispatch(
				companyActions.setCompanies(
					companies.map((company) => ({
						...company,
						id: company.id !== null ? company.id : DEFAULT_ID,
						code: String(company.id !== null ? company.id : DEFAULT_ID),
					}))
				)
			)

			onSuccess(user)

			if (initialCompany?.bin)
				dispatch(employerProfileThunks.getCompany({ id: currentFlEmployer ? DEFAULT_ID : initialCompany?.id || null }))
		} catch (error) {
			dispatch(actions.setError(error))
			onError()
		} finally {
			dispatch(actions.toggleLoading(false))
		}
	}
}
